module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-UltraBold.b9ab502.woff";